
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import Page from '@/Page.vue';
import { Component, Watch } from 'vue-property-decorator';
import moment from 'moment-timezone';

// Timezone pro zobrazování - vždy Praha bez ohledu na TZ prohlížeče
const DISPLAY_TIMEZONE = 'Europe/Prague';

import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { PlanItemModel, ProcessTypeEnum, TenantUserModel } from '@/libs/Api';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { planItemsStore } from '@/libs/plan-items/+state/store';
import { authStore } from '@/libs/auth/+store/store';
import { AuthGetter } from '@/libs/auth/models/auth-state';

moment.locale('cs');

@Component({
    components: {},
})
export default class DashboardWaitingPlanItems extends Page {
    today = new Date();
    tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
    itemsPerPage = 10;
    ProcessTypeEnum: typeof ProcessTypeEnum = ProcessTypeEnum;

    get headers() {
        return [
            { text: this.$i18n.t('planItems.time'), value: 'time', align: 'left', sortable: false },
            { text: this.$i18n.t('planItems.audit.name'), value: 'audit.name', align: 'left', sortable: false },
            { text: this.$i18n.t('planItems.category.name'), value: 'audit.category.name', align: 'left', sortable: false },
            { text: this.$i18n.t('planItems.user.displayName'), value: 'user.displayName', align: 'left', sortable: false },
            { text: '', value: 'id', align: 'left', sortable: false },
        ];
    }

    get loading(): boolean {
        return planItemsStore.useGetter(CrudGetter.PendingBasic, 'WaitingPlanItems');
    }

    get items(): PlanItemModel[] {
        return planItemsStore.useGetter(CrudGetter.DataBasic, 'WaitingPlanItems');
    }

    @Watch('itemsPerPage')
    itemsPerPageChanged(v: number) {
        window.localStorage.amsItemsPerPage = v.toString();
    }

    mounted() {
        this.itemsPerPage = window.localStorage.amsItemsPerPage ? Number(window.localStorage.amsItemsPerPage) : 10;
        this.loadItems();
    }

    loadItems() {
        planItemsStore.dispatch(
            CrudAction.GetAllBasic,
            createCrudQueryPayload<PlanItemModel>(
                { field: 'time', index: 1, order: 'desc' },
                [
                    {
                        field: 'isDeactivated',
                        op: 'eq',
                        comparand: false,
                    },
                    { field: 'time', op: 'gte', comparand: moment.tz(DISPLAY_TIMEZONE).add(-1, 'year').startOf('day').toDate() },
                    { field: 'time', op: 'lte', comparand: moment.tz(DISPLAY_TIMEZONE).add(-1, 'days').endOf('day').toDate() },
                    { field: 'isAnswered', op: 'eq', comparand: false },
                    //{ field: "responseCount", op: "eq", comparand: 0 },
                    { field: 'planItemAuditTenantUsers.tenantUserId', op: 'eq', comparand: this.tenantUser.id! },
                    { field: 'processType', op: 'eq', comparand: ProcessTypeEnum.Audit },
                ],
                undefined,
                false,
                'WaitingPlanItems'
            )
        );
    }
}
